import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { TEMPLATE_VISTEL, TEMPLATE_COLOR_THEME, TEMPLATE_GUIDE, TEMPLATE_COLOR_THEME_GUIDE } from '@/utils/constant'

import zhongShanRoutes from './modules/zhongshan'
import vistelDefaultRoutes from './modules/vistel'
import colorThemeRoutes from './modules/colortheme'
import colorGuideRoutes from './modules/color-guide'
import vistelGuideRoutes from './modules/vistel-guide'
import liyankeRoutes from './modules/liyanke'

Vue.use(Router)

// 兼容旧路由
const legacyRoutes = [
  {
    path: '/',
    redirect: '/zhongshan'
  },
  {
    path: '/:orgUid',
    meta: {
      isEntrance: true
    }
  },
  {
    path: '/chat/:orgUid',
    meta: {
      redirect: 'chat'
    }
  },
  {
    path: '/search/:orgUid',
    meta: {
      redirect: 'search'
    }
  }
]

const router = new Router({
  routes: [
    ...legacyRoutes,
    ...zhongShanRoutes,
    ...vistelDefaultRoutes,
    ...colorThemeRoutes,
    ...colorGuideRoutes,
    ...vistelGuideRoutes,
    ...liyankeRoutes
  ]
})

router.beforeEach((to, from, next) => {
  // 若机构模版需从后台获取，则需配置：1. 路由的meta.template为对应模版值 2. constant中配置模版
  if (to.meta.template || to.meta.isEntrance || to.meta.redirect) {
    let orgUid = to.params.orgUid;
    store.dispatch('getTheme', orgUid).then(({theme}) => {
      // 转换包含导诊模块的模板为对应基础模板
      theme = (theme === TEMPLATE_GUIDE && TEMPLATE_VISTEL) || (theme === TEMPLATE_COLOR_THEME_GUIDE && TEMPLATE_COLOR_THEME) || theme
      if (theme === to.meta.template) {
        next();
      } else if (theme === 'error') {
        vm.$vux.toast.show({
          type: 'text',
          text: '连接不上服务器，请检查网络',
          width: '15em',
          position: 'middle',
          isShowMask: true
        })
        next(false);
      } else if (to.meta.isEntrance) {
        // 跳转到对应模板首页
        next({
          path: `/${theme}/${orgUid}`
        });
      } else if (to.meta.redirect) {
        // 兼容旧url访问，跳转到对应模板页面
        let query = to.query || {};
        query.redirect = true;
        let params = Object.keys(query).map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(query[key]);
        }).join("&");
        next({
          path: `/${theme}/${to.meta.redirect}/${orgUid}?${params}`
        });
      } else {
        next({
          path: `/${orgUid}`
        })
      }
    })
  } else {
    next();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js